<template>
  <div class="banner">
    <el-col :span="24" class="action-bar">
      <!-- <span style="color:#888888;">轮播图管理:</span> -->
      <el-button type="primary" size="medium" @click="addBtnReset" style="margin: 0 20px;">新增</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="bannerList" highlight-current-row class="el-table-style">
      <el-table-column type="selection" min-width="55">
      </el-table-column>
      <el-table-column type="index" min-width="60" sortable>
      </el-table-column>
      <el-table-column label="图片" min-width="100" sortable>
        <template slot-scope="scope">
          <img :src="scope.row.img_url" style="object-fit:contain" width="250" height="150"/>
        </template>
      </el-table-column>
      <el-table-column prop="link_url" label="链接" min-width="100" sortable>
        <template slot-scope="scope">
          <div>
            <el-button type="primary"
                       v-clipboard:copy="scope.row.link_url"
                       v-clipboard:success="onCopy"
                       size="mini"
                       v-clipboard:error="onError">复制链接</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" min-width="100" sortable>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="getBannerDetail(scope.row.id)">编辑</el-button>
          <el-button type="danger" class="danger-btn" size="mini" @click="delBanner(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="footer-bar">
      <!-- <div class="batch"><el-button size="medium ">批量删除</el-button></div> -->
      <div class="page-code">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageTotal"
          :page-size="limit"
          :current-page="page"
          @current-change="reqBannerList"
        >
        </el-pagination>
      </div>
    </el-col>

    <!-- 新增 -->
    <el-dialog title="新增轮播图" :visible.sync="addFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            name="photo"
            :action="UPLOAD_IMG"
            :show-file-list="false"
            :on-success="addUploadSuccess"
          >
            <img v-if="addForm.imgUrl" :src="addForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 14px;color: grey">建议图片宽高比例为  678:391</div>
        </el-form-item>
        <el-form-item label="链接类型">
          <el-select v-model="addForm.link_type" clearable placeholder="请选择">
            <el-option    :key="0" label="页面路径" :value="0"/>
            <el-option    :key="1" label="公众号推文" :value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="addForm.linkUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="addForm.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCancelBtn">取消</el-button>
        <el-button type="primary" @click="addSubmitBtn">提交</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑轮播图" :visible.sync="editFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            name="photo"
            :action="UPLOAD_IMG"
            :show-file-list="false"
            :on-success="editUploadSuccess"
          >
            <img v-if="editForm.imgUrl" :src="editForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 14px;color: grey">建议图片宽高比例为  678:391</div>
        </el-form-item>
        <el-form-item label="链接类型">
          <el-select v-model="editForm.link_type" clearable placeholder="请选择">
            <el-option    :key="0" label="页面路径" :value="0"/>
            <el-option    :key="1" label="公众号推文" :value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="editForm.linkUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="editForm.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancelBtn">取消</el-button>
        <el-button type="primary" @click="editSubmitBtn">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {UPLOAD_IMG} from "@/api/index.js";
export default {

  data(){
    return{
      UPLOAD_IMG,
      pid:'',
      addFormVisible: false,//新增界面是否显示
      editFormVisible: false,//编辑界面是否显示
      addImageUrl:'',
      pageTotal:0,
      page: 1,
      limit:5,
      //新增界面数据
      addForm: {
        imgId:'',
        linkUrl:'',
        imgUrl:'',
        sort: '',
        section_classify_id:'',
        link_type:0
      },
      //编辑界面数据
      editForm: {
        id:'',
        imgId:'',
        linkUrl:'',
        imgUrl:'',
        sort: '',
        section_classify_id:'',
        link_type:0
      },
      bannerList:[],
    }
  },
  mounted(){
    this.pid = this.$route.query.id;
    this.addForm.section_classify_id=this.pid
    this.editForm.section_classify_id=this.pid
    this.reqBannerList();
  },
  methods:{
    onCopy(e){
      this.$message({
        type:'success',
        message:'复制成功'
      })
    },
    onError(erro){
      this.$message({
        type:'error',
        message:'复制失败'
      })
    },
    //新增上传图片成功回调
    addUploadSuccess(res, file) {
      if(res.data){
        this.addForm.imgUrl = res.data.img_url;
        this.addForm.imgId = res.data.id;
      }
    },
    //编辑上传图片成功回调
    editUploadSuccess(res, file) {
      if(res.data){
        this.editForm.imgUrl = res.data.img_url;
        this.editForm.imgId = res.data.id;
      }
    },
    //新增取消按钮
    addCancelBtn(){
      this.addForm.img = "";
      this.addForm.sort = "";
      this.addFormVisible = false;

    },
    //编辑取消按钮
    editCancelBtn(){
      this.editForm.id = "";
      this.editForm.img = "";
      this.editForm.sort = "";
      this.editFormVisible = false;
      this.editForm.imgUrl = '';
      this.editForm.link_type = 0;
    },
    //新增按钮重置表单
    addBtnReset(){
      this.addForm.img = "";
      this.addForm.sort = "";
      this.addForm.link_type = 0;
      this.addFormVisible = true;
    },
    //获取轮播图列表
    async reqBannerList(page){
      this.page = page || this.page
      let params = {
        limit:this.limit,
        page:this.page,
        type:'index',
        section_classify_id:this.pid
      }
      const res = await this.$api.getSectionClassifyBannerList(params);
      if(res.data.level=='success'){
        let list = res.data.data;
        this.bannerList = list;
        this.pageTotal = res.data.page_info.total
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //编辑获取轮播图信息
    async getBannerDetail(id){
      const params = {
        id: id
      }
      const res = await this.$api.getSectionClassifyBannerDetail(params);
      if(res.data.level=='success'){
        this.editForm.id = res.data.data.id;
        this.editForm.imgUrl = res.data.data.img_url;
        this.editForm.linkUrl = res.data.data.link_url;
        this.editForm.imgId = res.data.data.img_id;
        this.editForm.sort = res.data.data.sort;
        this.editForm.link_type = res.data.data.link_type;
        this.editFormVisible = true;
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //编辑提交按钮
    async editSubmitBtn(){
      const params = {
        id:this.editForm.id,
        img_id:this.editForm.imgId,
        link_url:this.editForm.linkUrl,
        sort:this.editForm.sort,
        link_type:this.editForm.link_type,
        section_classify_id:this.pid,
        status:1
        // type:'index'
      }
      const res = await this.$api.setSectionClassifyBanner(params);
      if(res.data.level=='success'){
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.editCancelBtn();
        this.reqBannerList();
        this.editForm.imgUrl = '';
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //新增提交按钮
    async addSubmitBtn(){
      const params = {
        img_id:this.addForm.imgId,
        link_url:this.addForm.linkUrl,
        sort:this.addForm.sort,
        link_type:this.addForm.link_type,
        section_classify_id:this.pid,
        type:'index'
      }
      const res = await this.$api.setSectionClassifyBanner(params);
      if(res.data.level=='success'){
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.addCancelBtn();
        this.reqBannerList();
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //删除轮播图
    async delBanner(id){
      const params = {
        id:id,
      }
      //删除
      const judge= this.$confirm('删除该banner?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        let res = await this.$api.delSectionClassifyBanner(params)
        if(res.data.level=='success'){
          this.reqBannerList();
          this.$message({
            type: 'success',
            message: res.data.message
          });
        }else{
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      }).catch(() => {
      });
    }
  }
}
</script>
<style lang='scss' scoped>
.banner{
  .action-bar{
    background-color: #f2f2f2;
    height: 60px;
    margin: 10px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .action-bar-input{
      width: 250px;
      margin-right: 14px;
    }
  }
  .el-table-style{
    width: 100%;
    border: 1px solid #f2f2f2;
  }
  .footer-bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    padding: 8px;
    margin: 10px 0px;
    box-sizing: border-box;
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>

<style>
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next
{
  background-color: #fff;
  border: 1px solid #f1f1f1;
  margin: 0;
}
.member .el-dialog__body{overflow: auto;}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/child_banner_subject/components/homepage.vue